import { DoDateServices } from "./Services.Interface";

const { REACT_APP_LOCAL } = process.env;
 let url_base = `${REACT_APP_LOCAL}/EnterpriseServices/Sel`;

 
let method = "POST";

export interface ResultadoEncuestaSatisfaccionRequest {
  ListaResultadoEncuestaSatisfaccion: ResultadoEnc;
}

export interface ResultadoEnc {
  Resultado: Question[];
}

export interface Question {
  Folio: string,
  UserID: string,
  CuentaSKY: string,
  Pais: string,
  Paquete: string,
  NoPregunta: number,
  Pregunta: string,
  Respuesta: string,
  Comentario: string
}

export interface ResultadoEncuestaSatisfaccionResponse {
  resultado: string,
  resultadodesc: string
}

export const getDataService_ResponderEncuesta = (
  resultadoEncuestaSatisfaccion: ResultadoEncuestaSatisfaccionRequest
) => {

  const doDataServices: DoDateServices = {
    serviceName: "Solicitud/responderEncuesta",
    url: url_base,
    method: method,
    request: JSON.stringify(resultadoEncuestaSatisfaccion)
  };

  return doDataServices;
};